/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Entity object. It has a entity type and properties of an entity.
 */
type Entity = {
  type: string;
  properties: Entity[];
};

/**
 * Grouping label
 */
export class GroupingLabel {
  displayName: string;

  constructor(displayName: string) {
    this.displayName = displayName;
  }

  static fromJson(json: any): GroupingLabel {
    const groupingLabel = new GroupingLabel(json.displayName);
    return groupingLabel;
  }
}

/**
 * Get entity labels for entity dropdown list from list of document entities
 * @param entities 
 * @returns 
 */
export function convertEntitiesToGroupingyLabels(
  entities: Entity[]
): GroupingLabel[] {
  let groupingLabels: GroupingLabel[] = [];
  entities?.forEach((entity: Entity) => {
    // only add grouping label if it does not exist yet
    if (
      !groupingLabels.some(
        (groupingLabel) => groupingLabel.displayName === entity.type
      )
    ) {
      let groupingLabel = new GroupingLabel(entity.type);
      groupingLabels.push(groupingLabel);
    }
  });
  return groupingLabels;
}